import { useState, useCallback } from 'react';
import { usePubsub } from './usePubsub';

const FILTER_SHOW_TOPIC = 'ws-locations-data/filter-visibility';

/**
 * Hook to listen for filter visibility changes published by
 * ws-locations-control's FilterToggleButton through DDC pubsub
 * (via ws-locations-data bus).
 *
 * @param {boolean} isReady - Whether LocationsData is ready
 * @returns {{ showFilter: boolean, hideFilter: function }}
 */
export const useShowFilterEvent = (isReady) => {
	const [showFilter, setShowFilter] = useState(false);

	const handleFilterChange = useCallback((data) => {
		if (data && typeof data.visible === 'boolean') {
			setShowFilter(data.visible);
		}
	}, []);

	usePubsub(FILTER_SHOW_TOPIC, handleFilterChange, isReady);

	const hideFilter = useCallback(() => {
		window.DDC?.pubsub?.publish(FILTER_SHOW_TOPIC, { visible: false });
	}, []);

	return { showFilter, hideFilter };
};
